import React, { useEffect, useState } from 'react'
import Header from '../header'
import Footer from '../footer'
import Steper from './components/steper'
import { useSelector } from 'react-redux'
import { langSelector } from '../../store/langSlice'
import CustomButton from '../../components/customButton'
import { getLang } from '../../environnement'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import StatutDialog from './components/statutDialog'

export default function EtatDemande() {
  const [etatDemande, setEtatDemande] = useState('');
  const [openDialog, setOpenDialog] = useState(false);

  const lang = useSelector(langSelector);
  const navigate = useNavigate();
  const location = useLocation();

  const [localState] = useState(location.state || null);

  useEffect(() => {
    console.log(localState.reservation);
    if (localState !== null) {
      if (localState.fromDemandeSalle) {
        setOpenDialog(true);
        toast.success(getLang(lang).reservationSalle.successDemande);
      }
      if (localState.reservation.statut === 'En cours') {
        setEtatDemande(`${getLang(lang).reservationSalle.votreDemandeNumero} ${localState.reservation.numero_demande} ${getLang(lang).reservationSalle.enCoursTraitement}`);
      } else if (localState.reservation.statut === 'Rejeté') {
        setEtatDemande(`${getLang(lang).reservationSalle.votreDemandeNumero} ${localState.reservation.numero_demande} ${getLang(lang).reservationSalle.rejete} ${localState.reservation.commentaire === null ? '' : getLang(lang).reservationSalle.information} ${localState.reservation.commentaire === null ? '' : localState.reservation.commentaire.commentaire}`);
      } else if (localState.reservation.statut === 'Accepté') {
        navigate('/confirmation-presence', {state : {reservation: localState.reservation}});
      }
    } else {
      navigate('/suivre-demande-login');
    }
  }, [localState, navigate, lang]);

  return (
    <div>
      <ToastContainer />
      <StatutDialog
        open={openDialog}
        numeroDemande={localState ? localState.reservation.numero_demande : '--'}
        handleClose={() => setOpenDialog(false)}
      />
      <Header />
      <div className='3xl:flex 3xl:justify-center' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}>
        <div className='3xl:w-[1200px] mx-10'>
          <Steper step={2}/>
          <div className='w-full border-dashed border-4 border-primary rounded-[30px] p-5 mb-6'>
            <p className='font-inter text-primary font-medium text-2xl sm:text-3xl text-center' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{etatDemande}</p>
          </div>
          <CustomButton
            value={getLang(lang).reservationSalle.faireAutreDemande}
            handelClick={() => navigate('/demande-salle')}
          />
        </div>
      </div>
      <Footer />
    </div>
  )
}
